import React from 'react';
import { view } from '@risingstack/react-easy-state';

export default view(({ device, hub }) => {
    return (
        <>
            <span>HELLO</span>
        </>
    )
})